import { render, staticRenderFns } from "./openData.vue?vue&type=template&id=5a2abd3e&scoped=true"
import script from "./openData.vue?vue&type=script&lang=js"
export * from "./openData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2abd3e",
  null
  
)

export default component.exports